import { call, take, put } from 'redux-saga/effects';
import { post, get } from '../../utils/api';
import settings from '../../utils/settings';
import {
  SITE_SEARCH_REQUEST_COMMON,
  SITE_SEARCH_SUCCESS_COMMON,
  SITE_SEARCH_FAILURE_COMMON,
  CREATE_SYSTEM_REQUEST_COMMON,
  CREATE_SYSTEM_SUCCESS_COMMON,
  CREATE_SYSTEM_FAILURE_COMMON,
  GET_SITE_DETAILS,
  GET_SITE_DETAILS_SUCCESS,
  GET_SITE_DETAILS_FAILURE,
} from './constants';
import { getToken } from '../../utils/helper';

export function* createSystemFlow() {
  while (true) {
    const request = yield take(CREATE_SYSTEM_REQUEST_COMMON);
    try {
      const {
        system,
        successCbk = () => {},
        failureCbk = () => {},
      } = request.payload;
      const response = yield call(post, {
        url: settings.digiCoreUrl('systems/new'),
        body: system,
        withBearer: true,
      });
      const { success, result } = response;
      if (success && result.system_id) {
        successCbk(result);
        yield put({ type: CREATE_SYSTEM_SUCCESS_COMMON });
      } else {
        yield put({
          type: CREATE_SYSTEM_FAILURE_COMMON,
          error:
            result[0] ||
            'System name already exists for the same Owner email ID. Please try again with different system name or owner email id',
        });
        failureCbk();
      }
    } catch (error) {
      yield put({ type: CREATE_SYSTEM_FAILURE_COMMON, error: error });
    }
  }
}

export function* getSiteSearchFlow() {
  while (true) {
    const request = yield take(SITE_SEARCH_REQUEST_COMMON);
    try {
      let response;
      const { searchValue, searchType } = request.payload;
      response = yield call(post, {
        url: settings.getDrsUrl(`proxyApi/request`),
        body: {
          url: [settings.getEnlightenApiUrl(`api_internal/sites/search`)],
          method: ['GET'],
          search_value: [searchValue.toString()],
          search_type: [searchType],
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: getToken(),
        },
      });
      if (response.success) {
        yield put({
          type: SITE_SEARCH_SUCCESS_COMMON,
          searchList: response.result,
        });
      } else {
        yield put({
          type: SITE_SEARCH_FAILURE_COMMON,
          error: response.result.message,
        });
      }
    } catch (error) {
      yield put({ type: SITE_SEARCH_FAILURE_COMMON, error: error });
    }
  }
}

export function* getSiteDetailsFlow() {
  while (true) {
    const request = yield take(GET_SITE_DETAILS);
    const { siteId, successCbk, failureCbk } = request.payload;
    try {
      let response;
      response = yield call(get, {
        url: settings.getDrsUrl(`applications/siteDetails/${siteId}`),
        withBearer: true,
      });
      if (response.success) {
        successCbk(response.result);
        yield put({ type: GET_SITE_DETAILS_SUCCESS });
      } else {
        yield put({ type: GET_SITE_DETAILS_FAILURE });
        failureCbk();
      }
    } catch (error) {
      yield put({ type: GET_SITE_DETAILS_FAILURE });
      failureCbk();
    }
  }
}
